var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDeleteSectionIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close=Close, Type=Filled",
    clipPath: "url(#clip0_1028_6109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12.3536 10.2323C12.1583 10.4276 11.8417 10.4276 11.6464 10.2323L9.52555 8.11068C9.3303 7.91536 9.01367 7.91533 8.81838 8.11062L8.11062 8.81838C7.91533 9.01367 7.91536 9.3303 8.11068 9.52555L10.2323 11.6464C10.4276 11.8417 10.4276 12.1583 10.2323 12.3536L8.11068 14.4744C7.91536 14.6697 7.91533 14.9863 8.11062 15.1816L8.81838 15.8894C9.01367 16.0847 9.3303 16.0846 9.52555 15.8893L11.6464 13.7677C11.8417 13.5724 12.1583 13.5724 12.3536 13.7677L14.4744 15.8893C14.6697 16.0846 14.9863 16.0847 15.1816 15.8894L15.8894 15.1816C16.0847 14.9863 16.0846 14.6697 15.8893 14.4744L13.7677 12.3536C13.5724 12.1583 13.5724 11.8417 13.7677 11.6464L15.8893 9.52555C16.0846 9.3303 16.0847 9.01367 15.8894 8.81838L15.1816 8.11062C14.9863 7.91533 14.6697 7.91536 14.4744 8.11068L12.3536 10.2323Z",
    fill: "#758AB9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1028_6109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteSectionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deleteSectionIcon.264d82a3.svg";
export { ForwardRef as ReactComponent };